import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react'

import { Input as AdminInput } from '@iws/admin-ui/input'

import { CameraScanButton } from '@/components/pos/scan/CameraScanButton'
import { cn } from '@/lib/utils'

type InputProps = ComponentPropsWithoutRef<typeof AdminInput> & {
  /** Puts the camera scanner inside the field (QR or barcode); called with each code read. */
  onCameraScan?: (code: string) => void
  /** Keep the camera open after a read. */
  continuousScan?: boolean
}

/** The admin input with the POS radius (6px). */
export const Input = forwardRef<ElementRef<typeof AdminInput>, InputProps>(({ className, onCameraScan, continuousScan, ...props }, ref) => {
  if (!onCameraScan) return <AdminInput ref={ref} className={cn('rounded-sm', className)} {...props} />
  return (
    // A grid stack, not `relative`: a positioned wrapper would paint over the pages' own leading icons.
    <div className="grid w-full min-w-0 [&>*]:[grid-area:1/1]">
      <AdminInput ref={ref} className={cn('rounded-sm pr-10', className)} {...props} />
      <CameraScanButton onScan={onCameraScan} continuous={continuousScan} className="relative mr-1.5 self-center justify-self-end" />
    </div>
  )
})
Input.displayName = 'Input'
